import { render, staticRenderFns } from "./addrecomment.vue?vue&type=template&id=2eda170f&scoped=true"
import script from "./addrecomment.vue?vue&type=script&lang=js"
export * from "./addrecomment.vue?vue&type=script&lang=js"
import style0 from "./addrecomment.vue?vue&type=style&index=0&id=2eda170f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda170f",
  null
  
)

export default component.exports